import { render, staticRenderFns } from "./peopleCollecDesc.vue?vue&type=template&id=7e34dc9e&scoped=true"
import script from "./peopleCollecDesc.vue?vue&type=script&lang=js"
export * from "./peopleCollecDesc.vue?vue&type=script&lang=js"
import style0 from "./peopleCollecDesc.vue?vue&type=style&index=0&id=7e34dc9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e34dc9e",
  null
  
)

export default component.exports